module.exports = __webpack_public_path__ + "img/aside-mid-zh.72ebf65c.png";